import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { DashboardFilterDropdowns } from "./DashboardFilterDropdowns"
import type { DashboardTab } from "../state/dashboardReducer"

interface BuyerOption {
  id: number
  label: string
}

interface DashboardFiltersMobileDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  activeTab: DashboardTab
  selectedNetworks: string[]
  onNetworksChange: (values: string[]) => void
  selectedBuyerStatuses: string[]
  onBuyerStatusesChange: (values: string[]) => void
  selectedAccountStatuses: string[]
  onAccountStatusesChange: (values: string[]) => void
  selectedBuyers: number[]
  onBuyersChange: (ids: number[]) => void
  buyerOptions: BuyerOption[]
}

export function DashboardFiltersMobileDialog({
  open,
  onOpenChange,
  ...filterProps
}: DashboardFiltersMobileDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85dvh] overflow-y-auto border-[#4a4a4a] bg-[#2d2d2d] text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white">Filters</DialogTitle>
          <DialogDescription className="text-[#b0b0b0]">
            Refine analytics by network, status, and media buyer.
          </DialogDescription>
        </DialogHeader>
        <DashboardFilterDropdowns layout="stacked" {...filterProps} />
      </DialogContent>
    </Dialog>
  )
}
